import { useEffect, useState, useMemo } from 'react';
import { useRedirectByRole, parseJwt, getAccessToken, getRefreshToken, clearStorage } from '@blocs.auth';
import { useLocation } from 'react-router-dom';

export const useCheckToken = (): void => {
  const location = useLocation();
  const query = useMemo(() => new URLSearchParams(location.search), [location.search]);

  useEffect(() => {
    if (query.get('clearLocalStorage')) {
      clearStorage();
    }
  }, [location, query]);

  useEffect(() => {
    try {
      const jwt = parseJwt(getAccessToken());

      if (!jwt) {
        clearStorage();
      }
    } catch (e) {
      clearStorage();
    }
  }, []);
};

export const useCheckRedirectToken = (): void => {
  const [tokens, setTokens] = useState<{ access: string; refresh: string }>(null);

  useCheckToken();

  useEffect(() => {
    const access = getAccessToken();
    const refresh = getRefreshToken();

    if (access && refresh) {
      setTokens({ access, refresh });
    }
  }, []);

  useRedirectByRole(tokens);
};
